import TopNav from './TopNav'
import styled from 'styled-components';

const TopNavResponsive = styled(TopNav)`
  
  @media screen and (max-width: 600px) {
    .show {
      display: block;
    }

    .hide {
      display: none;
    }
    
    .icon {
      display: block;
    }
  }
`

export default TopNavResponsive